import React, { useState, useEffect } from 'react';
import axios from '../../http';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../../components/ConfirmDialog';

const ProctorManager = () => {
  const [proctors, setProctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    first_name: '',
    last_name: ''
  });

  useEffect(() => {
    fetchProctors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showArchived]);

  const fetchProctors = async () => {
    try {
      const params = showArchived ? '?include_archived=true' : '';
      const res = await axios.get(`/api/admin/proctors${params}`);
      setProctors(res.data);
    } catch (err) {
      console.error('Failed to load proctors', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/admin/proctors', formData);
      setFormData({ username: '', password: '', first_name: '', last_name: '' });
      fetchProctors();
      setShowModal(false);
      alert('Proctor Added');
    } catch (err) {
      alert('Failed to add proctor. Username might be taken.');
    }
  };

  const handleDeactivate = (proctor) => {
    setConfirm({
      message: `Deactivate ${proctor.first_name} ${proctor.last_name}? They will no longer be able to log in, but all historical testing records they recorded will be preserved.`,
      confirmLabel: 'Deactivate',
      destructive: true,
      onConfirm: async () => {
        try {
          await axios.patch(`/api/admin/proctors/${proctor.id}/deactivate`);
          fetchProctors();
        } catch (err) {
          alert('Failed to deactivate proctor');
        }
      }
    });
  };

  const handleReactivate = async (proctor) => {
    try {
      await axios.patch(`/api/admin/proctors/${proctor.id}/reactivate`);
      fetchProctors();
    } catch (err) {
      alert('Failed to reactivate proctor');
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <ConfirmDialog confirm={confirm} onCancel={() => setConfirm(null)} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}
      >
        <h1>Proctor List</h1>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => setShowArchived((v) => !v)}
            style={showArchived ? { background: '#fef3c7', color: '#92400e', border: '1px solid #f6d860' } : {}}
          >
            {showArchived ? '📁 Showing Archived' : '📁 Show Archived'}
          </button>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>
            + Add Proctor
          </button>
          <Link to="/admin/dashboard" className="btn btn-secondary">
            Back
          </Link>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="wizard-modal">
            <h3>Add New Proctor</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>First Name</label>
                <input
                  className="form-input"
                  value={formData.first_name}
                  onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  className="form-input"
                  value={formData.last_name}
                  onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Username</label>
                <input
                  className="form-input"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  className="form-input"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
              </div>
              <div className="modal-actions">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Create Proctor
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            background: 'white',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        >
          <thead style={{ background: '#f7fafc' }}>
            <tr style={{ textAlign: 'left', borderBottom: '2px solid #edf2f7' }}>
              <th style={{ padding: '1rem' }}>Name</th>
              <th style={{ padding: '1rem' }}>Username</th>
              <th style={{ padding: '1rem', width: '90px' }}>Status</th>
              <th style={{ padding: '1rem', width: '130px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {proctors.map((p) => (
              <tr
                key={p.id}
                style={{
                  borderBottom: '1px solid #edf2f7',
                  opacity: p.is_active ? 1 : 0.55,
                  background: p.is_active ? 'white' : '#fafafa'
                }}
              >
                <td style={{ padding: '1rem' }}>{p.last_name}, {p.first_name}</td>
                <td style={{ padding: '1rem' }}>{p.username}</td>
                <td style={{ padding: '1rem' }}>
                  <span style={{
                    fontSize: '0.8rem',
                    fontWeight: '600',
                    color: p.is_active ? '#276749' : '#744210',
                    background: p.is_active ? '#c6f6d5' : '#fefcbf',
                    padding: '0.2rem 0.5rem',
                    borderRadius: '4px'
                  }}>
                    {p.is_active ? 'Active' : 'Archived'}
                  </span>
                </td>
                <td style={{ padding: '1rem' }}>
                  {p.is_active ? (
                    <button
                      onClick={() => handleDeactivate(p)}
                      className="btn btn-sm"
                      style={{ background: '#fed7d7', color: '#c53030' }}
                    >
                      Deactivate
                    </button>
                  ) : (
                    <button
                      onClick={() => handleReactivate(p)}
                      className="btn btn-sm"
                      style={{ background: '#c6f6d5', color: '#276749' }}
                    >
                      Reactivate
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ProctorManager;
